import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PROSPECTUS_TASK_BASE_PATH } from '../../../../../../../../../features/prospectus/task/prospectus-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'beta-nxt-prospectus-task-list',
        label: 'BetaNXT',
        to: PROSPECTUS_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
